module.exports = __webpack_public_path__ + "img/research2.22cc4bf3.jpg";